module.exports = __webpack_public_path__ + "img/noWaterSYJ.5e3e19f0.png";